<aza-rws-profile-header [titleTranslationKey]="titleTranslationKey" (closed)="onClosed()"></aza-rws-profile-header>
<aza-rws-pager (offsetChanged)="onPagingOffsetChanged($event)" [pagedResponseSubject]="pagedResponseSubject"
  [pageSize]="5"></aza-rws-pager>

<section class="aza-section aza-theme">
  <div class="aza-section-content aza-section-colors aza-event-list-filter-container">
    <div class="aza-form-field-area">
      <div class="aza-input-field aza-search-participant">
        <div class="aza-field-content aza-field-type-text">
          <input [(ngModel)]="participantSearchText" (input)="onFilterChanged()"
            placeholder="{{'SEARCH_PARTICIPANT' | translate}}" />
        </div>
      </div>
      <div class="aza-input-field aza-search-event">
        <div class="aza-field-content aza-field-type-text">
          <label class="aza-text">
            <input [(ngModel)]="eventSearchText" (input)="onFilterChanged()"
              placeholder="{{'SEARCH_EVENT' | translate}}" />
          </label>
        </div>
      </div>
      <div class="aza-my-organization">
        <label class="aza-text aza-my-organization-label">
          <input [(ngModel)]="myOrganization" (change)="onFilterChanged()" type="checkbox" />
          <span translate>MY_ORGANIZATION</span>
        </label>
      </div>
    </div>
  </div>
</section>

<div class="profile-events-list-container">
  <section *ngFor="let evt of events" (click)="onEventClick(evt)" class="aza-section aza-theme">
    <div class="aza-section-content profile-event">
      <div class="profile-event-name">
        <span>{{evt.name}}</span>
      </div>
      <div class="profile-event-description">
        <span>{{evt.description}}</span>
      </div>
      <div class="profile-event-start">
        <span translate>START</span>:
        <span>{{evt.start | eventDate:evt.timezone}}</span>
      </div>
      <div class="profile-event-end">
        <span translate>END</span>:
        <span>{{evt.end | eventDate:evt.timezone}}</span>
      </div>
      <div class="profile-event-timezone">
        <span>{{evt.timezone}}</span>
      </div>
      <div class="profile-event-first-name">
        <span translate>FIRST_NAME</span>:
        <span>{{evt.first_name}}</span>
      </div>
      <div class="profile-event-last-name">
        <span translate>LAST_NAME</span>:
        <span>{{evt.last_name}}</span>
      </div>
      <div class="profile-event-last-name">
        <span translate>EMAIL</span>:
        <span>{{evt.email}}</span>
      </div>
    </div>
    <section class="section-divider aza-section aza-theme">
      <div class="aza-section-content"></div>
    </section>
  </section>
</div>

<aza-rws-pager (offsetChanged)="onPagingOffsetChanged($event)" [pagedResponseSubject]="pagedResponseSubject"
  [pageSize]="5"></aza-rws-pager>
